/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      start_from: 'start_from',
    end_to: 'end_to',
    percentage: 'percentage',

};
